const ROUTES = {
  "/": {
    "name": "HomePage296811eb88ab4b5891b50fe7d26b7ec7",
    "type": "HTML",
    "key": "home-page"
  },
  "/_admin/*": {
    "name": "AdminPages77685f983e324c03Bde0F8e2a132ef2e",
    "type": "HTML",
    "key": "admin-pages"
  },
  "/about": {
    "name": "AboutUsPageD162191f8aee46d8B4e8A81e9a91bbf4",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/leveling": {
    "name": "AboutLevelingPage10caabd74a3543faA8a03cc87e25f717",
    "type": "HTML",
    "key": "about-leveling-page"
  },
  "/events/public": {
    "name": "PublicEventsPage6d644d16A54445e29aa27225b2564b14",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage9f16e4e15e9f4ff59b2eDfa081e46914",
    "type": "REFERENCE",
    "key": "join-us-page"
  },
  "/members/*": {
    "name": "MemberPagesCec4bc13E3904eb5Ae0c2027c80ad748",
    "type": "HTML",
    "key": "member-pages"
  },
  "/members/messages/*": {
    "name": "MessagePages609d72a22b0b4ad7B8c6390e7ed690e2",
    "type": "HTML",
    "key": "message-pages"
  },
  "/resources": {
    "name": "ResourcesPageCdf4ed73923948e8B26d665c00d51da6",
    "type": "REFERENCE",
    "key": "resources-page"
  },
  "/signup/*": {
    "name": "SignupPages5411187e679e4dfaA140E28ccc220f93",
    "type": "REFERENCE",
    "key": "signup-pages"
  }
};

export default ROUTES;